import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'math-greater', 'MathGreater', [["path",{"d":"M5 18l14 -6l-14 -6","key":"svg-0"}]]);